export default {
  Error: {
    404: 'Oops! Không tìm thấy trang.',
    '404_sub': 'Đường dẫn đang truy cập đã bị thay đổi hoặc không tồn tại',
    'goBack': 'Quay lại trang chủ',
    500: 'Internal Server Error!',
    '500_sub': 'Đã có lỗi xảy ra, vui lòng liên hệ MISA để được hỗ trợ.',
    403: 'Không có quyền truy cập',
    '403_sub': 'Bạn vui lòng liên hệ với admin để được cấp quyền truy cập ứng dụng',
  },
  Button: {
    BackAmis: 'Quay lại',
    ByNow: 'Mua ngay',
    ActiveNow: 'Gia hạn ngay',
    DeleteUser: 'Xóa người dùng',
  },
};
